import { Controller } from "stimulus";

export default class DrawerCqontroller extends Controller {
  static targets = ["drawer", "handle"];

  toggle() {
    this.drawerTarget.classList.toggle("translate-y-full");
  }

  open({ height }) {
    height = height + "px" || "50%";
    if (height) {
      this.drawerTarget.style.height = height;
    }
    this.drawerTarget.classList.remove("translate-y-full");
  }

  close() {
    this.drawerTarget.classList.add("translate-y-full");
  }

  // When the handle is swiped downwards, close the drawer
  handleSwipe(event) {
    if (event.touches.length > 0) {
      const touch = event.touches[0];
      const touchY = touch.clientY;
      const handleY = this.handleTarget.getBoundingClientRect().top;
      if (touchY > handleY) {
        this.close();
      }
    }
  }

}